import ContactPreChatDataAPI from '../../api/contactPreChatData';
import types from '../mutation-types';

const state = {
  records: {}, // keyed by contactId
  uiFlags: { isFetching: false, isUpdating: false },
};

const getters = {
  getUIFlags: $state => $state.uiFlags,
  getPreChatData: $state => contactId => $state.records[contactId] || [],
};

const mutations = {
  [types.SET_CONTACT_PRE_CHAT_DATA_UI_FLAG]($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  [types.SET_CONTACT_PRE_CHAT_DATA]($state, { contactId, data }) {
    $state.records = { ...$state.records, [contactId]: data };
  },
  [types.UPDATE_CONTACT_PRE_CHAT_FIELD](
    $state,
    { contactId, conversationId, fieldName, value }
  ) {
    const entries = $state.records[contactId] || [];
    const entry = entries.find(e => e.conversation_id === conversationId);
    if (entry) {
      const field = entry.fields.find(f => f.name === fieldName);
      if (field) field.value = value;
    }
  },
};

const actions = {
  async get({ commit }, contactId) {
    commit(types.SET_CONTACT_PRE_CHAT_DATA_UI_FLAG, { isFetching: true });
    try {
      const { data } = await ContactPreChatDataAPI.get(contactId);
      commit(types.SET_CONTACT_PRE_CHAT_DATA, {
        contactId,
        data: data.payload,
      });
    } catch (error) {
      // silently fail — section simply stays empty
    } finally {
      commit(types.SET_CONTACT_PRE_CHAT_DATA_UI_FLAG, { isFetching: false });
    }
  },

  async updateField(
    { commit },
    { contactId, conversationId, fieldName, value }
  ) {
    commit(types.SET_CONTACT_PRE_CHAT_DATA_UI_FLAG, { isUpdating: true });
    try {
      await ContactPreChatDataAPI.update(
        contactId,
        conversationId,
        fieldName,
        value
      );
      commit(types.UPDATE_CONTACT_PRE_CHAT_FIELD, {
        contactId,
        conversationId,
        fieldName,
        value,
      });
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_CONTACT_PRE_CHAT_DATA_UI_FLAG, { isUpdating: false });
    }
  },
};

export default { namespaced: true, state, getters, mutations, actions };
